export { default } from "./ArrayText";
